import { Box, Typography } from "@mui/material";
import { useLabCards } from "../utils/useLabsConfig";
import { MessyCardGrid } from "../components/card/MessyCardGrid";

export function HomePage() {
  const cardLabs = useLabCards();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "calc(100vh - 200px)",
        pt: 5,
        pb: 4,
      }}
    >
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ maxWidth: 620, textAlign: "center", mb: { xs: 4, sm: 8 }, px: 2 }}
      >
        <strong>Insight Labs</strong> allows users to experience{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "#78A842" }}>
          upcoming features
        </Box>
        , experimental{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "#286DB2" }}>
          user-interfaces
        </Box>{" "}
        and new and interesting{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "#e67e22" }}>
          data products
        </Box>
        .
      </Typography>

      <Box
        sx={{
          position: "relative",
          transform: "rotate(-1deg)",
          maxWidth: "95vw",
        }}
      >
        {/* Main border */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 4,
            p: "8px",
          }}
        >
          <Box
            sx={{
              borderRadius: 3,
              backgroundColor: "background.default",
              px: { xs: 1, sm: 4 },
              pt: { xs: 2, sm: 4 },
              pb: { xs: 10, sm: 16 },
            }}
          >
            <MessyCardGrid labs={cardLabs} />
          </Box>
        </Box>

        {/* Folder tab sticking out from the bottom */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 64,
            transform: "translateY(100%)",
            zIndex: -1,
            backgroundColor: "#fff",
            borderRadius: "0 0 12px 12px",
            px: 3,
            py: 1.5,
            maxWidth: 480,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 400,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "#333",
            }}
          >
            Labs Research & Components
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
